export let LiveSiteClicksOnMenuDropdownAndOptionInsideButtonName = /*#__PURE__*/function (LiveSiteClicksOnMenuDropdownAndOptionInsideButtonName) {
  LiveSiteClicksOnMenuDropdownAndOptionInsideButtonName["DROPDOWN"] = "dropdown";
  LiveSiteClicksOnMenuDropdownAndOptionInsideButtonName["DROPDOWN_MENU_OPTION"] = "dropdown menu option";
  return LiveSiteClicksOnMenuDropdownAndOptionInsideButtonName;
}({});
//# sourceMappingURL=constants.js.map